import React from 'react'
import Sheduler from '../../components/sheduler/Sheduler'
import { getToken } from '../../custome/action';
import Service from '../../components/service/Service';
import Contact from '../../components/contact/Contact';
import HeroSection from '../../components/heroSection/HeroSection';
import Header from '../../components/header/Header';
import Footer from '../../components/footer/Footer';
import About from '../../components/about/About';
import { useNavigate } from 'react-router-dom';
import Section1 from '../../components/highliterSection/Section1';
import SEO from '../../components/SEO/SEO';
import { breadcrumbSchema } from '../../components/SEO/structuredData';

export default function Home() {
    const navigate = useNavigate();
    const token = getToken();
    if (token !== null) {
        console.log("navigation")
        navigate("/dashboard")
    }

    const homePageBreadcrumb = breadcrumbSchema([
        { name: 'Home', url: 'https://www.manageecom.com/' }
    ]);

    return (
        <div className='bg-light'>
            <SEO
                title="Multichannel Listing & Inventory Management System | ManageEcom"
                description="ManageEcom provides an Inventory management software solution for the e-commerce industry that helps you to track orders, control stock, and manage your multichannel business efficiently. Best solution for Amazon, Flipkart, and other marketplace sellers."
                keywords="inventory management, ecommerce management, multichannel selling, order management, stock management, ManageEcom, amazon seller tools, flipkart seller software, marketplace management, inventory sync, payment reconciliation, dropshipping software"
                canonical={process.env.REACT_APP_MANAGEECOM_BASE_URL + "/"}
                structuredData={homePageBreadcrumb}
            />


            <Header />
            <HeroSection />
            <div className='container mt-nav' >
                <Section1/>
                <Sheduler />

                <div className="text-center title-section">
                    <h3 className='uppercase mainColor'>features</h3>
                    <h1 className='uppercase mainColor2'>Our Features and services.</h1>
                </div>
                <Service />

                <About />

                <div className="text-center title-section">
                    <h1 className='uppercase mainColor2'>Contact us</h1>
                </div>
                <Contact />

            </div>
            <Footer />
        </div>
    )
}
